import { TenantPage } from 'components/common';
import { EnhancedDataGrid } from 'components/common/enhanced/data-grid';
import { useTranslation } from 'react-i18next';
import { GridColDef } from '@mui/x-data-grid-premium';
import { AccessoryColumns } from 'components/common/enhanced/common-headers/accessories';
import { accessorService } from 'services/api/AccessorService';
import { Button, ButtonGroup } from '@mui/material';
import { IsTenantAdministrator } from 'components/helpers/IsTenantAdministrator';
import { Link } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
export const Accessories = () => {
  const translationPrefix = 'pages.accessories';
  const { t } = useTranslation();

  const columns: GridColDef[] = AccessoryColumns();

  return (
    <>
      <TenantPage
        title={t(`${translationPrefix}.title`)}
        subtitle={t(`${translationPrefix}.subtitle`)}
        menuRight={
          <div className="flex justify-end items-center">
            <ButtonGroup>
              <IsTenantAdministrator>
                <Link to="new">
                  <Button variant="outlined" size="small">
                    <AddIcon />
                    {t(`${translationPrefix}.add`)}
                  </Button>
                </Link>
              </IsTenantAdministrator>
            </ButtonGroup>
          </div>
        }>
        <EnhancedDataGrid columns={columns} service={accessorService} />
      </TenantPage>
    </>
  );
};

export default Accessories;
